<template>
    <el-card class="page_card" ref="card" style="overflow-y: auto" v-loading="!is_ok">
        <el-page-header @back="goBack" slot="header" :content="mode == 'add'?'添加企业信息':'修改企业信息'"></el-page-header>
        <!-- <el-steps :active="active" align-center>
            <el-step title="企业开户信息"></el-step>
            <el-step title="企业基本信息"></el-step>
            <el-step title="企业证照"></el-step>
        </el-steps> -->
        <el-row>
            <el-form ref="addForm" :rules="rules" :model="addForm" label-width="140px">
                <el-row>
                <el-col :lg="11" :sm="11" :xs="24">
                    <el-form-item label="企业名称" prop="name">
                        <el-input placeholder="企业名称" maxlength="40" show-word-limit v-model="addForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="企业简称" prop="abridge">
                        <el-input placeholder="企业名称" v-model="addForm.abridge" maxlength="5" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="企业法人" prop="legalName">
                        <el-input placeholder="企业法人" v-model="addForm.legalName" maxlength="10" show-word-limit></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="{span:11,offset:1}" :sm="{span:11,offset:1}" :xs="24">
                    <el-form-item label="开户行名称" prop="bankName">
                        <el-input placeholder="开户银行名称" v-model="addForm.bankName" maxlength="20" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="开户行地址" prop="bankAddress">
                        <el-input placeholder="开户行地址" v-model="addForm.bankAddress" maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="对公银行账号" prop="bankNumber">
                        <el-input placeholder="对公银行账号" v-model="addForm.bankNumber" maxlength="25" show-word-limit></el-input>
                    </el-form-item>
                </el-col>
                </el-row>
                <el-row>
                    <el-col :lg="11" :sm="11" :xs="24">
                    <el-form-item label="企业联系人" prop="contactName">
                        <el-input placeholder="企业联系人" v-model="addForm.contactName" maxlength="10" show-word-limit></el-input>
                    </el-form-item>
                     <el-form-item label="联系电话" prop="contactMobile">
                        <el-input placeholder="联系电话" v-model="addForm.contactMobile" maxlength="11" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="统一社会信用代码" prop="unifyNumber">
                        <el-input placeholder="统一社会信用代码" v-model="addForm.unifyNumber" maxlength="18" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="地址" prop="province">
                        <el-cascader
                            style="width: 100%"
                            v-model="addForm.province"
                            :options="address"
                        ></el-cascader>
                    </el-form-item>
                    <el-form-item label="详细地址" prop="address">
                        <el-input placeholder="详细地址" v-model="addForm.address" maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="企业类型">
                        <el-checkbox-group v-model="addForm.types">
                            <el-checkbox-button v-for="t in types" :label="t.id" :value="t.id" :key="t.id">{{t.label}}</el-checkbox-button>
                        </el-checkbox-group>
                    </el-form-item>
                </el-col>
                <el-col :lg="{span:11,offset:1}" :sm="{span:11,offset:1}" :xs="24">
                   <el-form-item label="邮寄地址" prop="mailAddr">
                        <el-input placeholder="邮寄地址" v-model="addForm.mailAddr" maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="产品" prop="goods"  v-if="mode == 'add'">
                        <el-select v-model="addForm.goods" multiple filterable allow-create default-first-option placeholder="请选择产品" @change="goodsChange" style="width:100%">
                            <el-option
                                v-for="item in goods_list"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="产品" prop="goods" v-if="mode == 'edit'">
                        <el-select v-model="addForm.goods" value-key="id"  multiple filterable allow-create default-first-option placeholder="请选择产品" @change="goodsChange" style="width:100%">
                            <el-option
                                v-for="item in goods_list"
                                :key="item.id"
                                :label="item.name"
                                :value="item">
                            </el-option>
                        </el-select>
                   </el-form-item>
                    <el-form-item label="信用额度" v-show="mode != 'add'" prop="credit">
                        <el-input placeholder="信用额度" v-model="addForm.credit" disabled maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="企业等级">
                        <el-rate
                            style="top: 9px;position: relative"
                            v-model="addForm.level"
                            :texts="['一级','二级','三级','四级','五级']"
                            show-text>
                        </el-rate>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input placeholder="备注" v-model="addForm.remark" :autosize="{ minRows: 8, maxRows:10}" maxlength="200" show-word-limit type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                </el-row>
                <el-row>
                    <el-col :lg="11" :sm="11" :xs="24">
                      <el-form-item label="营业执照:">
                        <el-date-picker style="margin-bottom:10px"
                            v-model="addForm.validEndDate"
                             value-format="yyyy-MM-dd"
                            type="daterange"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                        <el-row class="previews">
                            <el-upload
                            class="upload-demo"
                            drag
                            v-loading="loading1"
                            action=""
                            list-type="text"
                            :show-file-list="false"
                            :before-upload="beforeUpload1"
                            :http-request="uploadFile1"
                            :limit="5"
                            multiple>
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text"><em>点击上传</em></div>
                        </el-upload>
                            <div :class="file.type == 'pdf'?'preview pdf':'preview image'" v-for="(file,index) of fileList.length==0 ? fileList : fileList[0].url" :key="index">
                                <div class="pdf_icon" v-if="file.type=='pdf'">
                                    <svg-icon icon-class="pdf2" />
                                </div>
                                <div class="text" v-if="file.type=='pdf'">
                                    {{file.name}}
                                </div>
                                <div class="img" v-else style="height: 110px;border:1px">
                                    <el-image fit="cover" style="height: 110px;border-radius:10px;" :src="file.url"></el-image>
                                </div>
                                <div :class="file.type == 'pdf'?'btns':'img_btns'">
                                    <el-link style="margin-right: 5px;font-size: 1.2em" :underline="false" @click="preview(file,index,1)" size="mini" type="primary"><i class="el-icon-search" /></el-link>
                                    <el-link style="margin-left: 5px;font-size: 1.2em" :underline="false" @click="delFile(file,index,1)" size="mini" type="danger"><i class="el-icon-circle-close" /></el-link>
                                </div>
                            </div>
                        </el-row>
                    </el-form-item>
                        <el-form-item label="危化品经营许可证:">
                        <el-date-picker style="margin-bottom:10px"
                            v-model="addForm.validEndDate1"
                             value-format="yyyy-MM-dd"
                            type="daterange"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                        <el-row class="previews">
                            <el-upload
                            class="upload-demo"
                            drag
                            v-loading="loading2"
                            action=""
                            list-type="text"
                            :show-file-list="false"
                            :before-upload="beforeUpload2"
                            :http-request="uploadFile2"
                            :limit="5"
                            multiple>
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text"><em>点击上传</em></div>
                        </el-upload>
                            <div :class="file.type == 'pdf'?'preview pdf':'preview image'" v-for="(file,index) of fileList1.length==0 ? fileList1:fileList1[0].url" :key="index">
                                <div class="pdf_icon" v-if="file.type=='pdf'">
                                    <svg-icon icon-class="pdf2" />
                                </div>
                                <div class="text" v-if="file.type=='pdf'">
                                    {{file.name}}
                                </div>
                                <div class="img" v-else style="height: 110px;border:1px">
                                    <el-image fit="cover" style="height: 110px;border-radius:10px;" :src="file.url"></el-image>
                                </div>
                                <div :class="file.type == 'pdf'?'btns':'img_btns'">
                                    <el-link style="margin-right: 5px;font-size: 1.2em" :underline="false" @click="preview(file,index,2)" size="mini" type="primary"><i class="el-icon-search" /></el-link>
                                    <el-link style="margin-left: 5px;font-size: 1.2em" :underline="false" @click="delFile(file,index,2)" size="mini" type="danger"><i class="el-icon-circle-close" /></el-link>
                                </div>
                            </div>
                        </el-row>
                    </el-form-item>
                </el-col>
                <el-col :lg="{span:11,offset:1}" :sm="{span:11,offset:1}" :xs="24">
                       <el-form-item label="燃气经营许可证:">
                        <el-date-picker style="margin-bottom:10px"
                            v-model="addForm.validEndDate2"
                            value-format="yyyy-MM-dd"
                            type="daterange"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                        <el-row class="previews">
                            <el-upload
                            class="upload-demo"
                            drag
                            v-loading="loading3"
                            action=""
                            list-type="text"
                            :show-file-list="false"
                            :before-upload="beforeUpload3"
                            :http-request="uploadFile3"
                            :limit="5"
                            multiple>
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text"><em>点击上传</em></div>
                        </el-upload>
                            <div :class="file.type == 'pdf'?'preview pdf':'preview image'" v-for="(file,index) of fileList2.length==0 ? fileList2 : fileList2[0].url" :key="index">
                                <div class="pdf_icon" v-if="file.type=='pdf'">
                                    <svg-icon icon-class="pdf2" />
                                </div>
                                <div class="text" v-if="file.type=='pdf'">
                                    {{file.name}}
                                </div>
                                <div class="img" v-else style="height: 110px;border:1px">
                                    <el-image fit="cover" style="height: 110px;border-radius:10px;" :src="file.url"></el-image>
                                </div>
                                <div :class="file.type == 'pdf'?'btns':'img_btns'">
                                    <el-link style="margin-right: 5px;font-size: 1.2em" :underline="false" @click="preview(file,index,3)" size="mini" type="primary"><i class="el-icon-search" /></el-link>
                                    <el-link style="margin-left: 5px;font-size: 1.2em" :underline="false" @click="delFile(file,index,3)" size="mini" type="danger"><i class="el-icon-circle-close" /></el-link>
                                </div>
                            </div>
                        </el-row>
                    </el-form-item>
                        <el-form-item label="道路运输许可证:">
                        <el-date-picker style="margin-bottom:10px"
                            v-model="addForm.validEndDate3"
                             value-format="yyyy-MM-dd"
                            type="daterange"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                        <el-row class="previews">
                            <el-upload
                            class="upload-demo"
                            drag
                            v-loading="loading4"
                            action=""
                            list-type="text"
                            :show-file-list="false"
                            :before-upload="beforeUpload4"
                            :http-request="uploadFile4"
                            :limit="5"
                            multiple>
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text"><em>点击上传</em></div>
                        </el-upload>
                            <div :class="file.type == 'pdf'?'preview pdf':'preview image'" v-for="(file,index) of fileList3.length==0 ? fileList3 : fileList3[0].url" :key="index">
                                <div class="pdf_icon" v-if="file.type=='pdf'">
                                    <svg-icon icon-class="pdf2" />
                                </div>
                                <div class="text" v-if="file.type=='pdf'">
                                    {{file.name}}
                                </div>
                                <div class="img" v-else style="height: 110px;border:1px">
                                    <el-image fit="cover" style="height: 110px;border-radius:10px;" :src="file.url"></el-image>
                                </div>
                                <div :class="file.type == 'pdf'?'btns':'img_btns'">
                                    <el-link style="margin-right: 5px;font-size: 1.2em" :underline="false" @click="preview(file,index,4)" size="mini" type="primary"><i class="el-icon-search" /></el-link>
                                    <el-link style="margin-left: 5px;font-size: 1.2em" :underline="false" @click="delFile(file,index,4)" size="mini" type="danger"><i class="el-icon-circle-close" /></el-link>
                                </div>
                            </div>
                        </el-row>
                    </el-form-item>
                </el-col>
                </el-row>
                <el-row class="flex">
                    <el-col>
                        <el-form-item label="开票信息:">
                            <el-row class="previews">
                                <el-upload
                                class="upload-demo"
                                drag
                                v-loading="loading5"
                                action=""
                                list-type="text"
                                :show-file-list="false"
                                :before-upload="beforeUpload5"
                                :http-request="uploadFile5"
                                :limit="5"
                                multiple>
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text"><em>点击上传</em></div>
                            </el-upload>
                                <div :class="file.type == 'pdf'?'preview pdf':'preview image'" v-for="(file,index) of fileList4.length==0 ? fileList4 : fileList4[0].url" :key="index">
                                    <div class="pdf_icon" v-if="file.type=='pdf'">
                                        <svg-icon icon-class="pdf2" />
                                    </div>
                                    <div class="text" v-if="file.type=='pdf'">
                                        {{file.name}}
                                    </div>
                                    <div class="img" v-else style="height: 110px;border:1px">
                                        <el-image fit="cover" style="height: 110px;border-radius:10px;" :src="file.url"></el-image>
                                    </div>
                                    <div :class="file.type == 'pdf'?'btns':'img_btns'">
                                        <el-link style="margin-right: 5px;font-size: 1.2em" :underline="false" @click="preview(file,index,5)" size="mini" type="primary"><i class="el-icon-search" /></el-link>
                                        <el-link style="margin-left: 5px;font-size: 1.2em" :underline="false" @click="delFile(file,index,5)" size="mini" type="danger"><i class="el-icon-circle-close" /></el-link>
                                    </div>
                                </div>
                            </el-row>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="flex" v-if="mode == 'add'">
                    <el-col>
                        <el-form-item label="合同起始时间" prop="contractStartTime">
                            <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="addForm.contractStartTime" type="date" placeholder="起始时间"></el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col>
                        <el-form-item label="合同到期时间" prop="contractEndTime">
                            <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="addForm.contractEndTime" type="date" placeholder="到期时间"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row class="flex">
                    <el-form-item label="">
                        <el-button type="primary" v-if="mode == 'add'" plain :loading="is_post" @click="submit()">提 交</el-button>
                        <el-button type="warning" v-if="mode == 'edit'" plain :loading="is_post" @click="editSubmit()">提交修改</el-button>
                        <el-button plain v-if="mode == 'add'" :loading="is_post" @click="addreset()">重 置</el-button>
                    </el-form-item>
                </el-row>
            </el-form>
            
        </el-row>
        <!-- <el-row v-show="active==0">
            <el-form ref="addQForm" :rules="rules" :model="addForm" label-width="140px">
                <el-row>
                    <el-col :lg="11" :sm="11" :xs="24">
                     <el-form-item label="销售负责人" prop="uid">
                        <el-select v-model="addForm.uid" placeholder="请选择">
                            <el-option
                                v-for="item in sales_users"
                                :key="item.id"
                                :label="item.displayName"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-switch
                            style="display: block;top: 7px;position: relative"
                            v-model="addForm.status"
                            active-color="#13ce66"
                            inactive-color="#ff4949"
                            active-text="启用"
                            inactive-text="禁用">
                        </el-switch>
                    </el-form-item>
                    <el-form-item label="企业法人" prop="legalName">
                        <el-input placeholder="企业法人" v-model="addForm.legalName" maxlength="10" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="企业联系人" prop="contactName">
                        <el-input placeholder="企业联系人" v-model="addForm.contactName" maxlength="10" show-word-limit></el-input>
                    </el-form-item>
                     <el-form-item label="联系电话" prop="contactMobile">
                        <el-input placeholder="联系电话" v-model="addForm.contactMobile" maxlength="11" show-word-limit></el-input>
                    </el-form-item>
                </el-col>
                <el-col :lg="{span:11,offset:1}" :sm="{span:11,offset:1}" :xs="24">
                    <el-form-item label="开户行名称" prop="bankName">
                        <el-input placeholder="开户银行名称" v-model="addForm.bankName" maxlength="20" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="开户行地址" prop="bankAddress">
                        <el-input placeholder="开户行地址" v-model="addForm.bankAddress" maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="对公银行账号" prop="bankNumber">
                        <el-input placeholder="对公银行账号" v-model="addForm.bankNumber" maxlength="14" show-word-limit></el-input>
                    </el-form-item>
                </el-col>
                </el-row>
                <el-row>
                <el-button type="primary" plain @click="next(0)" style="float: right;">下一步</el-button>
            </el-row>
            </el-form>
            
        </el-row> -->
        <!-- <el-row v-show="active==1">
            <el-form ref="addJForm" :rules="addJForms" :model="addForm" label-width="140px">
                <el-row>
                     <el-col :lg="11" :sm="11" :xs="24">
                    <el-form-item label="企业名称" prop="name">
                        <el-input placeholder="企业名称" maxlength="20" show-word-limit v-model="addForm.name"></el-input>
                    </el-form-item>
                    <el-form-item label="企业简称" prop="abridge">
                        <el-input placeholder="企业名称" v-model="addForm.abridge" maxlength="5" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="统一社会信用代码" prop="unifyNumber">
                        <el-input placeholder="统一社会信用代码" v-model="addForm.unifyNumber" maxlength="18" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="地址" prop="province">
                        <el-cascader
                            style="width: 100%"
                            v-model="addForm.province"
                            :options="address"
                        ></el-cascader>
                    </el-form-item>
                    <el-form-item label="详细地址" prop="address">
                        <el-input placeholder="详细地址" v-model="addForm.address" maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="客户类型">
                        <el-checkbox-group v-model="addForm.types">
                            <el-checkbox-button v-for="t in types" :label="t.id" :value="t.id" :key="t.id">{{t.label}}</el-checkbox-button>
                        </el-checkbox-group>
                    </el-form-item>
                </el-col>
                <el-col :lg="{span:11,offset:1}" :sm="{span:11,offset:1}" :xs="24">
                   <el-form-item label="邮寄地址" prop="mailAddr">
                        <el-input placeholder="邮寄地址" v-model="addForm.mailAddr" maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="产品" prop="goods"  v-if="mode == 'add'">
                        <el-select v-model="addForm.goods" multiple filterable allow-create default-first-option placeholder="请选择产品" @change="goodsChange" style="width:100%">
                            <el-option
                                v-for="item in goods_list"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="产品" prop="goods" v-if="mode == 'edit'">
                        <el-select v-model="addForm.goods" value-key="id"  multiple filterable allow-create default-first-option placeholder="请选择产品" @change="goodsChange" style="width:100%">
                            <el-option
                                v-for="item in goods_list"
                                :key="item.id"
                                :label="item.name"
                                :value="item">
                            </el-option>
                        </el-select>
                   </el-form-item>
                    <el-form-item label="信用额度" v-show="mode != 'add'" prop="credit">
                        <el-input placeholder="信用额度" v-model="addForm.credit" disabled maxlength="50" show-word-limit></el-input>
                    </el-form-item>
                    <el-form-item label="客户等级">
                        <el-rate
                            style="top: 9px;position: relative"
                            v-model="addForm.level"
                            :texts="['一级','二级','三级','四级','五级']"
                            show-text>
                        </el-rate>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input placeholder="备注" v-model="addForm.remark" :autosize="{ minRows: 8, maxRows:10}" maxlength="200" show-word-limit type="textarea"></el-input>
                    </el-form-item>
                </el-col>
                </el-row>
                 <el-row>
                <el-button plain style="float:left" @click="prov(1)">上一步</el-button>
                <el-button plain style="float:right" type="primary" @click="next(1)">下一步</el-button>
            </el-row>
            </el-form>
        </el-row> -->
        <!-- <el-row v-show="active==2">
            <el-form ref="addZForm" :model="addForm" label-width="140px">
                <el-col :lg="11" :sm="11" :xs="24">
                      <el-form-item label="营业执照:">
                        <el-date-picker style="margin-bottom:10px"
                            v-model="addForm.validEndDate"
                             value-format="yyyy-MM-dd"
                            type="daterange"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                        <el-row class="previews">
                            <el-upload
                            class="upload-demo"
                            drag
                            action=""
                            list-type="text"
                            :show-file-list="false"
                            :before-upload="beforeUpload1"
                            :http-request="uploadFile1"
                            :limit="5"
                            multiple>
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text"><em>点击上传</em></div>
                        </el-upload>
                            <div :class="file.type == 'pdf'?'preview pdf':'preview image'" v-for="(file,index) of fileList.length==0 ? fileList : fileList[0].url" :key="index">
                                <div class="pdf_icon" v-if="file.type=='pdf'">
                                    <svg-icon icon-class="pdf2" />
                                </div>
                                <div class="text" v-if="file.type=='pdf'">
                                    {{file.name}}
                                </div>
                                <div class="img" v-else style="height: 110px;border:1px">
                                    <el-image fit="cover" style="height: 110px;border-radius:10px;" :src="file.url"></el-image>
                                </div>
                                <div :class="file.type == 'pdf'?'btns':'img_btns'">
                                    <el-link style="margin-right: 5px;font-size: 1.2em" :underline="false" @click="preview(file,index,1)" size="mini" type="primary"><i class="el-icon-search" /></el-link>
                                    <el-link style="margin-left: 5px;font-size: 1.2em" :underline="false" @click="delFile(file,index,1)" size="mini" type="danger"><i class="el-icon-circle-close" /></el-link>
                                </div>
                            </div>
                        </el-row>
                    </el-form-item>
                        <el-form-item label="危化品经营许可证:">
                        <el-date-picker style="margin-bottom:10px"
                            v-model="addForm.validEndDate1"
                             value-format="yyyy-MM-dd"
                            type="daterange"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                        <el-row class="previews">
                            <el-upload
                            class="upload-demo"
                            drag
                            action=""
                            list-type="text"
                            :show-file-list="false"
                            :before-upload="beforeUpload2"
                            :http-request="uploadFile2"
                            :limit="5"
                            multiple>
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text"><em>点击上传</em></div>
                        </el-upload>
                            <div :class="file.type == 'pdf'?'preview pdf':'preview image'" v-for="(file,index) of fileList1.length==0 ? fileList1:fileList1[0].url" :key="index">
                                <div class="pdf_icon" v-if="file.type=='pdf'">
                                    <svg-icon icon-class="pdf2" />
                                </div>
                                <div class="text" v-if="file.type=='pdf'">
                                    {{file.name}}
                                </div>
                                <div class="img" v-else style="height: 110px;border:1px">
                                    <el-image fit="cover" style="height: 110px;border-radius:10px;" :src="file.url"></el-image>
                                </div>
                                <div :class="file.type == 'pdf'?'btns':'img_btns'">
                                    <el-link style="margin-right: 5px;font-size: 1.2em" :underline="false" @click="preview(file,index,2)" size="mini" type="primary"><i class="el-icon-search" /></el-link>
                                    <el-link style="margin-left: 5px;font-size: 1.2em" :underline="false" @click="delFile(file,index,2)" size="mini" type="danger"><i class="el-icon-circle-close" /></el-link>
                                </div>
                            </div>
                        </el-row>
                    </el-form-item>
                </el-col>
                <el-col :lg="{span:11,offset:1}" :sm="{span:11,offset:1}" :xs="24">
                       <el-form-item label="燃气经营许可证:">
                        <el-date-picker style="margin-bottom:10px"
                            v-model="addForm.validEndDate2"
                            value-format="yyyy-MM-dd"
                            type="daterange"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                        <el-row class="previews">
                            <el-upload
                            class="upload-demo"
                            drag
                            action=""
                            list-type="text"
                            :show-file-list="false"
                            :before-upload="beforeUpload3"
                            :http-request="uploadFile3"
                            :limit="1"
                            multiple>
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text"><em>点击上传</em></div>
                        </el-upload>
                            <div :class="file.type == 'pdf'?'preview pdf':'preview image'" v-for="(file,index) of fileList2.length==0 ? fileList2 : fileList2[0].url" :key="index">
                                <div class="pdf_icon" v-if="file.type=='pdf'">
                                    <svg-icon icon-class="pdf2" />
                                </div>
                                <div class="text" v-if="file.type=='pdf'">
                                    {{file.name}}
                                </div>
                                <div class="img" v-else style="height: 110px;border:1px">
                                    <el-image fit="cover" style="height: 110px;border-radius:10px;" :src="file.url"></el-image>
                                </div>
                                <div :class="file.type == 'pdf'?'btns':'img_btns'">
                                    <el-link style="margin-right: 5px;font-size: 1.2em" :underline="false" @click="preview(file,index,3)" size="mini" type="primary"><i class="el-icon-search" /></el-link>
                                    <el-link style="margin-left: 5px;font-size: 1.2em" :underline="false" @click="delFile(file,index,3)" size="mini" type="danger"><i class="el-icon-circle-close" /></el-link>
                                </div>
                            </div>
                        </el-row>
                    </el-form-item>
                        <el-form-item label="道路运输许可证:">
                        <el-date-picker style="margin-bottom:10px"
                            v-model="addForm.validEndDate3"
                             value-format="yyyy-MM-dd"
                            type="daterange"
                            unlink-panels
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                        <el-row class="previews">
                            <el-upload
                            class="upload-demo"
                            drag
                            action=""
                            list-type="text"
                            :show-file-list="false"
                            :before-upload="beforeUpload4"
                            :http-request="uploadFile4"
                            :limit="1"
                            multiple>
                            <i class="el-icon-upload"></i>
                            <div class="el-upload__text"><em>点击上传</em></div>
                        </el-upload>
                            <div :class="file.type == 'pdf'?'preview pdf':'preview image'" v-for="(file,index) of fileList3.length==0 ? fileList3 : fileList3[0].url" :key="index">
                                <div class="pdf_icon" v-if="file.type=='pdf'">
                                    <svg-icon icon-class="pdf2" />
                                </div>
                                <div class="text" v-if="file.type=='pdf'">
                                    {{file.name}}
                                </div>
                                <div class="img" v-else style="height: 110px;border:1px">
                                    <el-image fit="cover" style="height: 110px;border-radius:10px;" :src="file.url"></el-image>
                                </div>
                                <div :class="file.type == 'pdf'?'btns':'img_btns'">
                                    <el-link style="margin-right: 5px;font-size: 1.2em" :underline="false" @click="preview(file,index,4)" size="mini" type="primary"><i class="el-icon-search" /></el-link>
                                    <el-link style="margin-left: 5px;font-size: 1.2em" :underline="false" @click="delFile(file,index,4)" size="mini" type="danger"><i class="el-icon-circle-close" /></el-link>
                                </div>
                            </div>
                        </el-row>
                    </el-form-item>
                     <el-form-item label="">
                        <el-button plain style="float:left" @click="prov(2)">上一步</el-button>
                        <el-button type="primary" v-if="mode == 'add'" plain :loading="is_post" @click="submit()">提 交</el-button>
                        <el-button type="warning" v-if="mode == 'edit'" plain :loading="is_post" @click="editSubmit()">提交修改</el-button>
                        <el-button plain v-if="mode == 'add'" :loading="is_post" @click="addreset()">重 置</el-button>
                    </el-form-item>
                </el-col>
            </el-form>
        </el-row> -->
       
        <el-dialog title="文件预览" :visible.sync="preview_dialog" width="60%">
            <el-row>
                <el-col :span="24" style="overflow-x: hidden;overflow-y: auto;height: 65vh" v-if="preview_file && preview_file.type != 'pdf'">
                    <el-image fit="cover" style="width: 100%" :src="preview_file.url" v-if="preview_file"></el-image>
                </el-col>
                <el-col :span="24" style="overflow-x: hidden;overflow-y: auto;height: 65vh" v-loading="is_show_pdf" v-if="preview_file && preview_file.type == 'pdf'">
                    <pdf ref="pdf"
                         style="width: 100%"
                         v-for="i in numPages"
                         :key="i"
                         :src="preview_file.url"
                         :page="i"></pdf>
                </el-col>
            </el-row>
        </el-dialog>
    </el-card>
</template>

<script>
import BMF from 'browser-md5-file';
const OSS = require('ali-oss');
import pdf from "vue-pdf"
import {deepClone} from "@/utils"
import request from "@/utils/request"
import {stringTrim} from "@/utils/elvalid"
import { json } from 'mathjs';

export default {
    name: 'add_company',
    components:{
        pdf
    },
    data(){
        return {
            mode:"add",
            is_ok:false,
            id:0,
            active:0,
            goods_list:[],
            distGoods:[],
            loading1: false,
            loading2: false,
            loading3: false,
            loading4: false,
            loading5: false,
            addForm:{
                address:"",
                name:"",
                abridge:"",
                unifyNumber:"",
                isUnified:true,
                province:null,
                types:[0],
                level:1,
                uid:"",
                status:true,
                remark:"",
                bankNumber:"",
                bankAddress:"",
                bankName:"",
                contactMobile:"",
                legalName:"",
                mailAddr:"",
                credit:"",
                goods:[],
                contactName:"",
                attachUrls:[],
                validEndDate:[],
                validEndDate1:[],
                validEndDate2:[],
                validEndDate3:[],
                contractStartTime:'',
                contractEndTime:'',

            },
            typeData:[
                {id:0,name:'营业执照'},
                {id:1,name:'危化品经营许可证'},
                {id:2,name:'道路运输许可证'},
                {id:3,name:'燃气经营许可证'},
                {id:4,name:'银行开户许可证'}
            ],
            rules:{

                legalName:[
                    { required: true, message: '请输入该企业法人', trigger: 'blur' },
                    { validator:stringTrim, trigger: 'blur' },
                    { min: 1, max: 10, message: '最长不超过10个字符', trigger: 'blur' }
                ],
                contactName:[
                    { required: true, message: '请输入该企业联系人姓名', trigger: 'blur' },
                    { validator:stringTrim, trigger: 'blur' },
                    { min: 1, max: 10, message: '最长不超过10个字符', trigger: 'blur' }
                ],
                contactMobile:[
                    { required: true, message: '请输入联系人联系方式', trigger: 'blur' },
                    { pattern:/^1[345789]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                ],
                bankName:[
                    // { required: true, message: '请输入开户行名称', trigger: 'blur' },
                    // { validator:stringTrim, trigger: 'blur' },
                    { min: 1, max: 10, message: '最长不超过10个字符', trigger: 'blur' }
                ],
                bankAddress:[
                    // { required: true, message: '请输入开户行地址', trigger: 'blur' },
                    // { validator:stringTrim, trigger: 'blur' },
                    { min: 1, max: 50, message: '最长不超过50个字符', trigger: 'blur' }
                ],
                bankNumber:[
                    // { required: true, message: '请输入对公银行账号', trigger: 'blur' },
                    { pattern:/^\d{12}|\d{25}$/, message: '请输入正确的银行账号', trigger: 'blur' }
                ],
                uid:[
                    { required: true, message: '请选择一个销售负责人', trigger: 'blur' }
                ],
                address:[
                    { required: true, message: '请输入该企业详细地址', trigger: 'blur' },
                    { validator:stringTrim, trigger: 'blur' },
                    { min: 1, max: 50, message: '最长不超过50个字符', trigger: 'blur' }
                ],
                name:[
                    { required: true, message: '请输入该企业名称', trigger: 'blur' },
                    { validator:stringTrim, trigger: 'blur' },
                    { min: 1, max: 40, message: '最长不超过40个字符', trigger: 'blur' }
                ],
                abridge:[
                    { required: true, message: '请输入该企业简称', trigger: 'blur' },
                    { validator:stringTrim, trigger: 'blur' },
                    { min: 1, max: 5, message: '最长不超过5个汉字', trigger: 'blur' }
                ],
                unifyNumber:[
                    { required: true, message: '请输入该企业统一社会信用代码', trigger: 'blur' },
                    //{ pattern:/^[0-9A-Z]{18}$/, message: '请填写正确的统一社会信用代码', trigger: 'blur' }
                ],
                province:[
                    { required: true, message: '请选择该企业所在省市区', trigger: 'blur' },
                ],
                 mailAddr:[
                    { required: true, message: '请输入邮寄地址', trigger: 'blur' }
                ],
                goods:[
                    { required: true, message: '请选择产品', trigger: 'blur' }
                ],
                credit:[
                    // { required: true, message: '请输入信用额度', trigger: 'blur' },
                    { pattern:/^([1-9]\d*|0)(\.\d{2})?$/, message: '信用额度只能输入两位小数', trigger: 'blur' }
                ],
                contractStartTime:[
                    { required: true, message: '请选择合同起始时间', trigger: 'blur' },
                    { validator: stringTrim, trigger: 'blur' },
                ],
                contractEndTime:[
                    { required: true, message: '请选择合同结束时间', trigger: 'blur' },
                    { validator: stringTrim, trigger: 'blur' },
                ],
            },
            addJForms:{
                address:[
                    { required: true, message: '请输入该企业详细地址', trigger: 'blur' },
                    { validator:stringTrim, trigger: 'blur' },
                    { min: 1, max: 50, message: '最长不超过50个字符', trigger: 'blur' }
                ],
                name:[
                    { required: true, message: '请输入该企业名称', trigger: 'blur' },
                    { validator:stringTrim, trigger: 'blur' },
                    { min: 1, max: 20, message: '最长不超过20个字符', trigger: 'blur' }
                ],
                abridge:[
                    { required: true, message: '请输入该企业简称', trigger: 'blur' },
                    { validator:stringTrim, trigger: 'blur' },
                    { min: 1, max: 5, message: '最长不超过5个汉字', trigger: 'blur' }
                ],
                unifyNumber:[
                    { required: true, message: '请输入该企业统一社会信用代码', trigger: 'blur' },
                    //{ pattern:/^[0-9A-Z]{18}$/, message: '请填写正确的统一社会信用代码', trigger: 'blur' }
                ],
                province:[
                    { required: true, message: '请选择该企业所在省市区', trigger: 'blur' },
                ],
                 mailAddr:[
                    { required: true, message: '请输入邮寄地址', trigger: 'blur' }
                ],
                goods:[
                    { required: true, message: '请选择产品', trigger: 'blur' }
                ],
                credit:[
                    // { required: true, message: '请输入信用额度', trigger: 'blur' },
                    { pattern:/^([1-9]\d*|0)(\.\d{2})?$/, message: '信用额度只能输入两位小数', trigger: 'blur' }
                ]
            },
            fileList:[],
            fileList1:[],
            fileList2:[],
            fileList3:[],
            fileList4:[],
            salers:[],
            sales_users:[

            ],
            // goodsName:'',
            is_post:false,
            types:[
                {id:0,label:"贸易商"},
                {id:1,label:"加气站"},
                {id:2,label:"终端客户"},
                {id:3,label:"物流公司"}
                
            ],
            address:[],
            uploadOption:null,
            preview_dialog:false,
            numPages:null,
            preview_file:null,
            is_show_pdf:false
        }
    },
    methods:{
         getGoodsList(){
            request.get("goods/dropdown").then(res=>{
                this.goods_list = res.data;
            }).catch(err=>{
            });
        },
        goodsChange(ids){
            var distGoodList=[];
            if(this.mode == "add"){
                if(ids.length>0){
                    for (let i = 0; i < ids.length; i++) {
                        for (let j = 0; j < this.goods_list.length; j++) {
                        if(this.goods_list[j].id==ids[i]){
                            distGoodList.push(this.goods_list[j]);
                        }
                        }
                    }
                }
            }
            if(this.mode == "edit"){
                if(ids.length>0){
                    for (let i = 0; i < ids.length; i++) {
                        for (let j = 0; j < this.goods_list.length; j++) {
                        if(this.goods_list[j].id==ids[i].id){
                            distGoodList.push(this.goods_list[j]);
                        }
                        }
                    }
                }
            }
            
            var distGoods = [];
           distGoodList.forEach((el, index) => {
              var obj = {
                id: el.id,
                name: el.name,
              };
              distGoods.push(obj);
            });
            this.distGoods = distGoods;

        },
        loadAddress(){
            if(window.pandc){
                this.address = pandc;
                return false;
            }
            let el = document.createElement("script");
            el.src = "/address.js";
            el.onload = ()=>{
                this.address = window.pandc;
            }
            document.getElementsByTagName('head')[0].appendChild(el);
        },
        uploadSuccess(file,id){
            this.loading1=false;
            this.loading2=false;
            this.loading3=false;
            this.loading4=false;
            this.loading5=false;
            this.$message.success(`上传文件(${file.url[0].name})成功!`);
            if(id==0){
                this.fileList.push(file);
            }else if(id==1){
                this.fileList1.push(file);
            }else if(id==2){
                this.fileList2.push(file);
            }else if(id==4){
                this.fileList4.push(file);
            }else{
                this.fileList3.push(file);
            }
            
        },
        uploadFile1(e){
             this.uploadFile(e,0)
        },
        uploadFile2(e){
            this.uploadFile(e,1)
        },
        uploadFile3(e){
            this.uploadFile(e,2)
        },
        uploadFile4(e){
            this.uploadFile(e,3)
        },
        uploadFile5(e){
            this.uploadFile(e,4)
        },
        uploadFile(e,id){
            let {file} = e;
            if(id==0){
                if(this.fileList.length >= 1){
                    this.$message.warning("最多只能上传1个附件!");
                    return false;
                }
            }else if(id==1){
                if(this.fileList1.length >= 1){
                    this.$message.warning("最多只能上传1个附件!");
                    return false;
                }
            }else if(id==2){
                if(this.fileList2.length >= 1){
                    this.$message.warning("最多只能上传1个附件!");
                    return false;
                }
            }else if(id==4){
                if(this.fileList4.length >= 1){
                    this.$message.warning("最多只能上传1个附件!");
                    return false;
                }
            }else{
                if(this.fileList3.length >= 1){
                    this.$message.warning("最多只能上传1个附件!");
                    return false;
                }
            }
            if(!["application/pdf","image/jpeg","image/png","image/gif"].includes(file.type)){
                this.$message.warning("只支持pdf,jpeg,jpg,png,gif文件!");
                return false;
            }
            if(file.size > 1024*1024*20){
                this.$message.warning("文件最大支持上传20MB!");
                return false;
            }
            let errobj = {
                type:"",//size|mime|other
                msg:""
            };
            const bmf = new BMF();
            bmf.md5(file,(err, md5) => {
                //生成文件名
                let filename = md5+file.name.substring(file.name.lastIndexOf("."));
                let oldname = file.name;
                //文件夹
                let folder = "attach_file";
                //上传
                let readerBlob = new FileReader();
                readerBlob.onload = async (event)=>{
                    
                    let data = new OSS.Buffer(event.target.result);
                    let client = new OSS(this.uploadOption);
                    try {
                        let result = await client.put(folder+"/"+filename, data);
                        // console.log(result,'这是图片地址')
                        let obj={};
                        if(id==0){  
                           this.loading1=true;
                           let ImgUrl = {name:oldname,url:result.url,type:file.name.substring(file.name.lastIndexOf(".")+1)};
                           obj.id=id;
                           obj.type=0
                           obj.validStartDate=this.addForm.validEndDate[0]
                           obj.validEndDate=this.addForm.validEndDate[1]
                           obj.url=new Array(ImgUrl)
                        }else if(id==1){
                            this.loading2=true;
                            let ImgUrl = {name:oldname,url:result.url,type:file.name.substring(file.name.lastIndexOf(".")+1)};
                            obj.id=id;
                            obj.type=1
                            obj.validStartDate=this.addForm.validEndDate1[0]
                            obj.validEndDate=this.addForm.validEndDate1[1]
                            obj.url=new Array(ImgUrl)
                        }else if(id==2){
                            this.loading3=true;
                            let ImgUrl = {name:oldname,url:result.url,type:file.name.substring(file.name.lastIndexOf(".")+1)};
                            obj.id=id;
                            obj.type=2
                            obj.validStartDate=this.addForm.validEndDate2[0]
                            obj.validEndDate=this.addForm.validEndDate2[1]
                            obj.url=new Array(ImgUrl)
                        }else if(id==3){
                            this.loading4=true;
                            let ImgUrl = {name:oldname,url:result.url,type:file.name.substring(file.name.lastIndexOf(".")+1)};
                            obj.id=id;
                            obj.type=3
                            obj.validStartDate=this.addForm.validEndDate3[0]
                            obj.validEndDate=this.addForm.validEndDate3[1]
                            obj.url=new Array(ImgUrl)
                        }else if(id==4){
                            this.loading5=true;
                            let ImgUrl = {name:oldname,url:result.url,type:file.name.substring(file.name.lastIndexOf(".")+1)};
                            obj.id=id;
                            obj.type=4
                            obj.url=new Array(ImgUrl)
                        }
                        this.uploadSuccess(obj,id);
                    } catch (e) {
                        errobj.type = "other";
                        errobj.msg = e;
                        this.$message.warning(e.message);
                        return errobj;
                    }
                };
                readerBlob.readAsArrayBuffer(file);
            });
        },
        beforeUpload1(file){
            this.beforeUpload(file,0)
        },
        beforeUpload2(file){
            this.beforeUpload(file,1)
        },
        beforeUpload3(file){
            this.beforeUpload(file,2)
        },
        beforeUpload4(file){
            this.beforeUpload(file,3)
        },
        beforeUpload5(file){
            this.beforeUpload(file,4)
        },
        async beforeUpload(file,id){
            if(id==0){
                if(this.fileList.length >= 1){
                    return false;
                }
            }else if(id==1){
                if(this.fileList1.length >= 1){
                    return false;
                }
            }else if(id==2){
                if(this.fileList2.length >= 1){
                    return false;
                }
            }else if(id==4){
                if(this.fileList4.length >= 1){
                    return false;
                }
            }else{
                if(this.fileList3.length >= 1){
                    return false;
                }
            }
            if(!["application/pdf","image/jpeg","image/png","image/gif"].includes(file.type)){
                return false;
            }
            if(file.size > 1024*1024*20){
                return false;
            }
            try{
                this.uploadOption = await this.$store.dispatch("upload/getAccessToken");
            } catch(e){
                this.$message.warning(e.message);
                return false;
            }
            return true;
        },
        back(){
            this.$router.replace({
                path: '/redirect' + "/customer/company"
            });
        },
        submit(){
            let data = deepClone(this.addForm);
             this.$refs["addForm"].validate(valid=>{
                    if(!valid) return false;
                    if(this.addForm.validEndDate.length==0){
                            this.$message.error('选择营业执照有效日期')
                            return false;
                        }
                        if(this.fileList.length<1){
                            this.$message.error('上传公司营业执照')
                            return false;
                        }
                                        // {id:0,label:"贸易商"},
                                        // {id:1,label:"加气站"},
                                        // {id:2,label:"终端客户"},
                                        // {id:3,label:"物流公司"}
                        if(this.addForm.types.indexOf(0)!==-1){
                            if(this.addForm.validEndDate1.length==0){
                                this.$message.error('选择危化品经营许可证有效日期')
                                return false;
                            }
                            if(this.fileList1.length<1){
                                this.$message.error('上传危化品经营许可证')
                                return false;
                            }
                        }
                        if(this.addForm.types.indexOf(1)!==-1){
                            if(this.addForm.validEndDate2.length==0){
                                this.$message.error('选择燃气经营许可证有效日期')
                                return false;
                            }
                            if(this.fileList2.length<1){
                                this.$message.error('上传燃气经营许可证')
                                return false;
                            }
                        }
                        if(this.addForm.types.indexOf(2)!==-1){
                            if(this.addForm.validEndDate2.length==0){
                                this.$message.error('选择燃气经营许可证有效日期')
                                return false;
                            }
                            if(this.fileList2.length<1){
                                this.$message.error('上传燃气经营许可证')
                                return false;
                            }
                        }
                        if(this.addForm.types.indexOf(3)!==-1){
                            if(this.addForm.validEndDate3.length==0){
                                this.$message.error('选择道路运输许可证有效日期')
                                return false;
                            }
                            if(this.fileList3.length<1){
                                this.$message.error('上传道路运输许可证')
                                return false;
                            }
                        }
                        if(!!this.addForm.validEndDate){
                            if(this.addForm.validEndDate.length!=0){
                                this.fileList[0].validStartDate=this.addForm.validEndDate[0];
                                this.fileList[0].validEndDate=this.addForm.validEndDate[1];
                            }
                        }
                        if(!!this.addForm.validEndDate1){
                            if(this.addForm.validEndDate1.length!=0){
                                this.fileList1[0].validStartDate=this.addForm.validEndDate1[0];
                                this.fileList1[0].validEndDate=this.addForm.validEndDate1[1];
                            }
                        }

                        if(!!this.addForm.validEndDate2){
                            if(this.addForm.validEndDate2.length!=0){
                                this.fileList2[0].validStartDate=this.addForm.validEndDate2[0];
                                this.fileList2[0].validEndDate=this.addForm.validEndDate2[1];
                            }
                        }
                        if(!!this.addForm.validEndDate3){
                            if(this.addForm.validEndDate3.length!=0){
                                this.fileList3[0].validStartDate=this.addForm.validEndDate3[0];
                                this.fileList3[0].validEndDate=this.addForm.validEndDate3[1];
                            }
                        }
                        data.attachUrls.push(this.fileList[0]);
                        data.attachUrls.push(this.fileList1[0]);
                        data.attachUrls.push(this.fileList2[0]);
                        data.attachUrls.push(this.fileList3[0]);
                        // data.attachUrls.push(this.fileList4[0]);
                        data.invoice=this.fileList4[0];
                        data.distGoods=this.distGoods;
                        this.is_post = true;
                        request.post("company/create",data).then(res=>{
                            this.$confirm('添加公司信息成功,是否继续添加?', '提示', {
                                confirmButtonText: '继续添加',
                                cancelButtonText: '跳转至公司列表页',
                                type: 'warning'
                            }).then(() => {
                                this.addreset();
                            }).catch(() => {
                                this.addreset();
                                this.$router.replace({
                                    path: "/customer/company"
                                });
                            });
                            this.is_post = false;
                        }).catch(err=>{
                            this.is_post = false;
                        });
                    });
        },
        //移除文件
        delFile(file,index,id){
            if(id==1){
                this.fileList.splice(index,1);
            }else if(id==2){
                this.fileList1.splice(index,1);
            }else if(id==3){
                this.fileList2.splice(index,1);
            }else if(id==5){
                this.fileList4.splice(index,1);
            }else{
                this.fileList3.splice(index,1);
            }
            
        },
        async preview(file,index){
            if(file.type == "pdf"){
                //pdf
                this.preview_file = file;
                this.preview_dialog = true;
                this.is_show_pdf = true;
                await this.getNumPages(file.url);
                this.is_show_pdf = false;
            }else{
                this.preview_file = file;
                this.preview_dialog = true;
            }
        },
        getNumPages(url) {
            return new Promise((resolve,reject)=>{
                let loadingTask = pdf.createLoadingTask(url)
                loadingTask.promise.then(pdf => {
                    this.numPages = pdf.numPages
                    resolve();
                }).catch(err => {
                    console.error('pdf 加载失败', err);
                    this.is_show_pdf = false;
                    reject(err);
                })
            });
        },
        addreset(){
            this.active=0;
            this.fileList = [];
            this.fileList1 = [];
            this.fileList2 = [];
            this.fileList3 = [];
            this.addForm.address='';
            this.addForm.name="";
            this.addForm.abridge="";
            this.addForm.unifyNumber="";
            this.addForm.isUnified=true;
            this.addForm.province=null;
            this.addForm.types=[0];
            this.addForm.level=1;
            this.addForm.uid="";
            this.addForm.status=true;
            this.addForm.remark="";
            this.addForm.bankNumber="";
            this.addForm.bankAddress="";
            this.addForm.bankName="";
            this.addForm.contactMobile="";
            this.addForm.legalName="";
            this.addForm.mailAddr="";
            this.addForm.goods=[];
            this.addForm.credit="";
            this.addForm.contactName="";
            this.addForm.attachUrls=[];
            this.addForm.validEndDate=[];
            this.addForm.validEndDate1=[];
            this.addForm.validEndDate2=[];
            this.addForm.validEndDate3=[];
        },
        goBack(){
            this.$router.back();
        },
        getSalers(){
            request.get("company/sellers_option").then(res=>{
                this.sales_users = this.sales_users.concat(res.data);
            }).catch(err=>{
                console.log(err);
            });
        },
        getData(){
            return new Promise((resolve, reject)=>{
                request.get("company/detail?id="+this.id).then(res=>{
                    for(let k of Object.keys(this.addForm)){
                        if(typeof res.data[k] != "undefined"){
                            if(k == "attachUrls"){
                                res.data.attachUrls.map((data,index)=>{
                                    if(data.type==0){
                                        this.addForm.validEndDate.push(data.validStartDate);
                                        this.addForm.validEndDate.push(data.validEndDate);
                                        this.fileList.push({url:[]})
                                        this.fileList[0].type=data.type;
                                        this.fileList[0].validStartDate=this.addForm.validEndDate[0];
                                        this.fileList[0].validEndDate=this.addForm.validEndDate[1];
                                        (JSON.parse(data.attachUrls)).map((d,i)=>{
                                            this.fileList[0].url.push(d);
                                        })
                                    }else if(data.type==1){
                                        this.addForm.validEndDate1.push(data.validStartDate);
                                        this.addForm.validEndDate1.push(data.validEndDate);
                                        this.fileList1.push({url:[]})
                                        this.fileList1[0].type=data.type;
                                        this.fileList1[0].validStartDate=this.addForm.validEndDate1[0];
                                        this.fileList1[0].validEndDate=this.addForm.validEndDate1[1];
                                        (JSON.parse(data.attachUrls)).map((d,i)=>{
                                            this.fileList1[0].url.push(d);
                                        })
                                    }else if(data.type==2){
                                        this.addForm.validEndDate2.push(data.validStartDate);
                                        this.addForm.validEndDate2.push(data.validEndDate);
                                         this.fileList2.push({url:[]})
                                        this.fileList2[0].type=data.type;
                                        this.fileList2[0].validStartDate=this.addForm.validEndDate2[0];
                                        this.fileList2[0].validEndDate=this.addForm.validEndDate2[1];
                                        (JSON.parse(data.attachUrls)).map((d,i)=>{
                                            this.fileList2[0].url.push(d);
                                        })

                                    }else if(data.type==3){
                                        this.addForm.validEndDate3.push(data.validStartDate);
                                        this.addForm.validEndDate3.push(data.validEndDate);
                                         this.fileList3.push({url:[]})
                                        this.fileList3[0].type=data.type;
                                        this.fileList3[0].validStartDate=this.addForm.validEndDate3[0];
                                        this.fileList3[0].validEndDate=this.addForm.validEndDate3[1];
                                        (JSON.parse(data.attachUrls)).map((d,i)=>{
                                            this.fileList3[0].url.push(d);
                                        })
                                    }
                                })
                            }else if(k == "status"){
                                this.addForm[k] = res.data[k] == 1?true:false;
                            }else if(k == "province"){
                                this.addForm[k] = [res.data["province"],res.data["city"],res.data["county"]];
                            }else{
                                this.addForm[k] = res.data[k];
                            }
                        }
                    }
                    this.distGoods=res.data.goods;
                    this.is_ok = true;
                    resolve(res.data);

                }).catch(err=>{
                    this.is_ok = true;
                    reject(err);
                });
            });
        },
        editSubmit(){
            let data = deepClone(this.addForm);
            this.$refs["addForm"].validate(valid=>{
                    if(!valid) return false;
                
                    if(this.addForm.validEndDate.length==0){
                        this.$message.error('选择营业执照有效日期')
                        return false;
                    }
                    if(this.fileList.length<1){
                        this.$message.error('上传公司营业执照')
                        return false;
                    }
                    if(this.addForm.types.indexOf(0)!==-1){
                        if(this.addForm.validEndDate1.length==0){
                            this.$message.error('选择危化品经营许可证有效日期')
                            return false;
                        }
                        if(this.fileList1.length<1){
                            this.$message.error('上传危化品经营许可证')
                            return false;
                        }
                    }
                    if(this.addForm.types.indexOf(1)!==-1){
                        if(this.addForm.validEndDate2.length==0){
                            this.$message.error('选择燃气经营许可证有效日期')
                            return false;
                        }
                        if(this.fileList2.length<1){
                            this.$message.error('上传燃气经营许可证')
                            return false;
                        }
                    }
                    if(this.addForm.types.indexOf(2)!==-1){
                        if(this.addForm.validEndDate2.length==0){
                            this.$message.error('选择燃气经营许可证有效日期')
                            return false;
                        }
                        if(this.fileList2.length<1){
                            this.$message.error('上传燃气经营许可证')
                            return false;
                        }
                    }
                    if(this.addForm.types.indexOf(3)!==-1){
                        if(this.addForm.validEndDate3.length==0){
                            this.$message.error('选择道路运输许可证有效日期')
                            return false;
                        }
                        if(this.fileList3.length<1){
                            this.$message.error('上传道路运输许可证')
                            return false;
                        }
                    }    
                    if(!!this.addForm.validEndDate){
                        if(this.addForm.validEndDate.length!=0){
                            this.fileList[0].validStartDate=this.addForm.validEndDate[0];
                            this.fileList[0].validEndDate=this.addForm.validEndDate[1];
                        }
                    }
                    if(!!this.addForm.validEndDate1){
                        if(this.addForm.validEndDate1.length!=0){
                            this.fileList1[0].validStartDate=this.addForm.validEndDate1[0];
                            this.fileList1[0].validEndDate=this.addForm.validEndDate1[1];
                        }
                    }

                    if(!!this.addForm.validEndDate2){
                        if(this.addForm.validEndDate2.length!=0){
                            this.fileList2[0].validStartDate=this.addForm.validEndDate2[0];
                            this.fileList2[0].validEndDate=this.addForm.validEndDate2[1];
                        }
                    }
                    if(!!this.addForm.validEndDate3){
                        if(this.addForm.validEndDate3.length!=0){
                            this.fileList3[0].validStartDate=this.addForm.validEndDate3[0];
                            this.fileList3[0].validEndDate=this.addForm.validEndDate3[1];
                        }
                    }
                    // if(this.addForm.validEndDate.length!=0){
                    // this.fileList[0].validStartDate=this.addForm.validEndDate[0];
                    // this.fileList[0].validEndDate=this.addForm.validEndDate[1];
                    // }
                    // if(this.addForm.validEndDate1.length!=0){
                    // this.fileList1[0].validStartDate=this.addForm.validEndDate1[0];
                    // this.fileList1[0].validEndDate=this.addForm.validEndDate1[1];
                    // }
                    // if(this.addForm.validEndDate2.length!=0){
                    // this.fileList2[0].validStartDate=this.addForm.validEndDate2[0];
                    // this.fileList2[0].validEndDate=this.addForm.validEndDate2[1];
                    // }
                    // if(this.addForm.validEndDate3.length!=0){
                    // this.fileList3[0].validStartDate=this.addForm.validEndDate3[0];
                    // this.fileList3[0].validEndDate=this.addForm.validEndDate3[1];
                    // }
                    data.attachUrls.push(this.fileList[0]);
                    data.attachUrls.push(this.fileList1[0]);
                    data.attachUrls.push(this.fileList2[0]);
                    data.attachUrls.push(this.fileList3[0]);
                    data.distGoods=this.distGoods;
                    data.invoice=this.fileList4[0];
                    data.id = this.id;
                    this.is_post = true;
                    request.post("company/edit",data).then(res=>{
                        this.$message.success("修改公司信息成功!");
                        this.is_post = false;
                        this.$router.replace({
                                path: "/customer/company"
                            });
                    }).catch(err=>{
                        this.is_post = false;
                    });
                });
        },
         prov(th){
            this.active = parseInt(th) -1;
        },
        next(th){
           if(th==0){
                this.$refs["addQForm"].validate(valid=>{
                    if(!valid) return false;
                    this.active = parseInt(th) + 1;
                });
           }else if(th==1){
                this.$refs["addJForm"].validate(valid=>{
                    if(!valid) return false;
                    this.active = parseInt(th) + 1;
                });
           }
            
        },
    },
    created(){
        if(this.$route.name == "edit_company"){
            this.mode = "edit";
            this.id = this.$route.params.id;
            this.getData();
        }else{
            this.mode = "add";
            this.is_ok = true;
        }
        this.getSalers();
    },
    mounted() {
        this.loadAddress();
        this.getGoodsList();
    }
}

</script>

<style lang="scss">
.upload-demo {
    .el-icon-upload {
        margin: 10px 0 16px !important;
   }
   .el-upload.el-upload--text .el-upload-dragger {
        width: 130px !important;
        height: 110px !important;
    }
}
.previews{
    display: flex;
    align-items: center;

    .preview{
        width: 200px;
        height: 112px;
        border: 1px dashed #ddd;
        border-radius: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        position: relative;
        top:-5px;
        left:20px;
        &.pdf{
            padding: 0 10px;
        }

        &:hover{
            border-color: #1890ff;
            .img_btns{
                display: flex;
            }
        }

        .text{
            line-height: 15px;
            width: 100%;
            font-size: 12px;
            color: #bbb;
            margin-top: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            text-align: center;
        }

        .img_btns{
            display: none;
            background: rgba(0,0,0,0.6);
            border-radius: 10px;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            justify-content: center;
            align-items: center;
        }

        .btns{
            font-size: 16px;
        }
        .pdf_icon{
            font-size: 50px;
            font-weight: 700;
            color: #bbb;
        }
    }
}
.flex{
    display: flex;
    justify-content: center;
}
</style>
